let lastScrollTop = 0;
const header = document.querySelector('header');

document.body.addEventListener('scroll', function() {
  const scrollTop = document.body.scrollTop;

  if (scrollTop > lastScrollTop) {
    // 向下滚动 → 收起
    header.classList.add('header-hidden');
  } else {
    // 向上滚动 → 显示
    header.classList.remove('header-hidden');
  }
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
}, false);